export const siteConfig = {
  name: "همراه هوشمند",
  shortName: "همراه هوشمند",
  title: "همراه هوشمند | سامانه الکترونیک خدمات قضایی ایرانیان خارج از کشور",
  description:
    "کارگزاری رسمی سامانه ثنا برای ایرانیان خارج از کشور؛ ثبت‌نام و احراز هویت ثنا، گواهی عدم سوءپیشینه، مشاهده ابلاغیه و پیگیری پرونده، بدون نیاز به حضور در ایران.",
  locale: "fa-IR",
  language: "fa",
  direction: "rtl" as const,
  siteUrl: import.meta.env.VITE_SITE_URL || "http://localhost:5173",
  apiUrl: import.meta.env.VITE_API_URL || "http://localhost:3000",
  apiMode: import.meta.env.VITE_API_MODE || "mock",
  defaultTheme: "stripe",
  socialImage: "/images/social-card.svg",
} as const;
